import React from "react";
import MiniModalWrapper from "ui-kit/MiniModalWrapper";
import { connect } from "react-redux";
import * as R from "ramda";
import { BigFilledButton, BigOutlineButton, Div } from "components/Base";
import { Divider } from "EventLight/Common";
import CSSModules from "react-css-modules";
import styles from "./styles.scss";
import { actions } from "../model";

import { getAccentColor } from "Portal/NewPortal/PortalHome/selectors";

const decorate = R.compose(
  connect(
    state => ({
      accentColor: getAccentColor(state)
    }),
    {
      onCancel: actions.onCancelUnsavedChanges,
      onConfirm: actions.onConfirmUnsavedChanges
    }
  ),
  CSSModules(styles)
);

const UnsavedChangesModal = ({ onCancel, onConfirm, accentColor }) => {
  return (
    <MiniModalWrapper
      title="Unsaved Changes"
      hideModal={onCancel}
      width={500}
      height="auto"
      showModal
      stopPropagation
      bg={"white"}
      isPortal={true}
      showHeader={false}
    >
      <div styleName="confirmModalBody">
        <div styleName="confirmModalWarning">You have unsaved changes. </div>
        Would you like to save them before proceeding?
      </div>
      <Divider my={0} />
      <Div display="row.flex-start" py={4} px={6}>
        <BigFilledButton bg={accentColor} mr={3} onClick={onConfirm}>
          Yes
        </BigFilledButton>
        <BigOutlineButton color="neutral7" onClick={onCancel}>
          Cancel
        </BigOutlineButton>
      </Div>
    </MiniModalWrapper>
  );
};

export default decorate(UnsavedChangesModal);
